/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by maximeallex on 2018-07-18.
 */

'use strict';

import { SafeHtml } from '@angular/platform-browser';

export class ModalAction {
  shape: 'square'|'round';
  color: string;
  label: SafeHtml|string;
  onClick: (...args: Array<any>) => Promise<any>|void;
  hidden: (...args: Array<any>) => boolean;
  disable: (...args: Array<any>) => boolean;
  type: 'validate'|'dismiss'|undefined;

  constructor(config?: ActionConfiguration, hasType?: 'validate'|'dismiss') {
    if ( !config ) {
      config = {} as ActionConfiguration;
    }
    this.shape = config.shape || 'square';
    this.color = config.color;
    this.label = ( config.label )
      ? config.label
      : ( hasType === 'dismiss' )
        ? 'Cancel'
        : 'OK';
    this.onClick = config.onClick;
    this.hidden = ( config.hidden ) ? config.hidden : () => false;
    this.disable = ( config.disable ) ? config.disable : () => false;
    this.type = hasType;
  }
}

export interface ActionConfiguration {
  label: SafeHtml|string;
  onClick: (...args: Array<any>) => Promise<any>|void;
  hidden?: (...args: Array<any>) => boolean;
  disable?: (...args: Array<any>) => boolean;
  shape?: 'square'|'round';
  color?: string;
}
